// extracted by mini-css-extract-plugin
module.exports = {"style_model_item":"style-component_style_model_item__Dgbin","model_mages":"style-component_model_mages__y09d2","right_arrow":"style-component_right_arrow__P770X"};